<template>
    <card-grid-item
        :tab-widget="tabWidget"
        :card-class="['card-grid']"
        :min-w="3"
        :min-h="minHeight"
        :resized="handleResized"
        @tab-widget-settings-click="handleTabWidgetSettingsClick"
    >
        <template v-slot:card-title>
            {{ title }}
        </template>

        <template v-slot:card-body>
            <arrivals-card-grid
                :getDataEndpoint="getDataEndpoint"
                :getDataParams="getDataParams"
                :cardGridKey="cardGridKey"
                :limit="limit"
                :tabWidget="tabWidget"
            />
        </template>

        <template v-slot:tab-widget-settings-modal>
            <tab-widget-settings-modal-form
                :modal-id="tabWidgetSettingsModalID"
                :update="updateTabWidgetSettings"
                :initial-values="tabWidgetSettingsInitialValues"
                @success-update="handleSuccessTabWidgetSettingsUpdate"
                :withBlockedReservations="true"
                :withTableFontSize="true"
            ></tab-widget-settings-modal-form>
        </template>
    </card-grid-item>
</template>

<script>
import ArrivalsCardGrid from '../common/arrivals-card-grid.vue'
import CardGridItem from '../common/card-grid-item.vue'
import TabWidgetSettingsModalForm from '../common/tab-widget-settings-modal-form.vue'
import { getWidgetGridRowsNumber } from '../helpers'
import { DASHBOARD_ARRIVALS_GRID_ENDPOINT } from '../../../../endpoints'
import { DATE_PERIOD_FUTURE } from '../../../../constants'
import cardGridItemBaseMixin from '../common/card-grid-item-base-mixin'

export default {
    name: 'AllArrivalsTableCardGridItem',
    mixins: [cardGridItemBaseMixin],
    components: {
        ArrivalsCardGrid,
        CardGridItem,
        TabWidgetSettingsModalForm,
    },
    data() {
        return {
            limit: getWidgetGridRowsNumber({
                tabWidget: this.tabWidget,
            }),
        };
    },
    computed: {
        getDataParams() {
            return {
                period: DATE_PERIOD_FUTURE
            }
        },
        getDataEndpoint() {
            return DASHBOARD_ARRIVALS_GRID_ENDPOINT();
        },
        tabWidgetSettingsInitialValues() {
            return {
                settings: {
                    name: this.tabWidget.settings.name || this.defaultName,
                    display_blocked_reservations:
                        this.tabWidget.settings.display_blocked_reservations,
                    table_font_size: this.tabWidget.settings.table_font_size || this.defaultWidgetFontSize,
                },
            };
        },
    },
    methods: {
        handleResized() {
            this.limit = getWidgetGridRowsNumber({
                tabWidget: this.tabWidget,
            });
            this.cardGridKey += 1;
        },
    },
};
</script>
